import { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  text: {
    primary: '#FFFFFF',
    secondary: '#8F8F8F',
  },
  primary: {
    light: '#6366f126',
    main: '#4F46E5', // indigo 600
    dark: '#6366f1', // indigo 500
    contrastText: '#FFFFFF',
  },
  primaryExtended: {
    opacityBackgroundText: '#818cf8', // indigo 400
    opacityBackgroundBackground: '#818cf826',
  },
  background: {
    default: '#1D1D1D',
    paper: '#161616',
  },
  backgroundExtended: {
    card: '#242425',
  },
  backdrop: {
    default: '#000000ac',
  },
  common: {
    black: '#000000',
    white: '#FFFFFF',
  },
  error: {
    light: '#f8717126', // dark + 26
    main: '#ef4444', // red 500
    dark: '#f87171', // red 400
    contrastText: '#FFFFFF',
  },
  warning: {
    light: '#fbbf2426', // dark + 26
    main: '#f59e0b', // amber 500
    dark: '#fbbf24', // amber 400
    contrastText: '#FFFFFF',
  },
  info: {
    light: '#60a5fa26', // dark + 26
    main: '#3b82f6', // blue 500
    dark: '#60a5fa', // blue 400
    contrastText: '#FFFFFF',
  },
  success: {
    light: '#34d39926', // dark + 26
    main: '#10b981', // emerald 500
    dark: '#34d399', // emerald 400
    contrastText: '#FFFFFF',
  },
  divider: '#2B2B2B',
  grey: {
    900: '#FCF6FA',
    800: '#F4EEF2',
    700: '#848484',
    600: '#787878',
    500: '#5B5B5B',
    400: '#3E3E3E',
    300: '#353535',
    200: '#2C2C2C',
    100: '#2A2A2A',
    50: '#232323',
  },
  goalImpact: {
    high: { background: '#E9E6F9', text: '#818cf8' },
    medium: { background: '#F1F5FE', text: '#818cf8B3' },
    low: { background: '#F4F4F4', text: '#818cf84D' },
  },
};
